import React from "react";

interface BodyProps {
  putOverlay: boolean;
  qsmActive: boolean;
}

const Body: React.FC<BodyProps> = ({ putOverlay, qsmActive }) => {
  return <body className={`${qsmActive ? "ios-keyboard-open" : ""} ${putOverlay ? "has-overlay" : ""}`} />;
};

export default Body;
